import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";
import { NavProvider } from "./components/Header/Navbar/context/NavContext.jsx";
import { GlobalStyle } from "./styles/GlobalStyle";
import App from "./App.jsx";
import { preloadFonts } from "./utils/preloadFonts";
// import { PreloadHeroImage } from "./utils/preloadHeroImages";

// preload fonts immediately
preloadFonts();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <NavProvider>
          <GlobalStyle />
          {/* <PreloadHeroImage /> */}
          <App />
        </NavProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
